var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"9"}},_vm._l((_vm.components),function(component){return _c('component-card',{key:component.id,attrs:{"component":component}})}),1),_c('b-col',{attrs:{"md":"3"}},[_c('community-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }